import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
	name: 'safeResourceUrl',
	standalone: true
})
export class SafeResourceUrlPipe implements PipeTransform {

	private sanitizer = inject(DomSanitizer);

	transform(url: string | null | undefined): SafeResourceUrl | undefined {
		if (!url) {
			return undefined;
		}
		return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}
} 